var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRobot401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Session_expired_graphic",
    "data-name": "Session expired graphic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 548.956,
    height: 380.308,
    viewBox: "0 0 548.956 380.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31989",
    "data-name": "Rectangle 31989",
    width: 548.956,
    height: 380.308,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31944",
    "data-name": "Rectangle 31944",
    width: 16.44,
    height: 9.132,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31945",
    "data-name": "Rectangle 31945",
    width: 15.416,
    height: 6.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31946",
    "data-name": "Rectangle 31946",
    width: 41.073,
    height: 50.928,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31947",
    "data-name": "Rectangle 31947",
    width: 67.752,
    height: 55.651,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31948",
    "data-name": "Rectangle 31948",
    width: 41.564,
    height: 6.47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31949",
    "data-name": "Rectangle 31949",
    width: 38.069,
    height: 5.926,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31950",
    "data-name": "Rectangle 31950",
    width: 34.504,
    height: 5.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31951",
    "data-name": "Rectangle 31951",
    width: 70.408,
    height: 37.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31952",
    "data-name": "Rectangle 31952",
    width: 24.074,
    height: 55.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31953",
    "data-name": "Rectangle 31953",
    width: 17.495,
    height: 42.605,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31954",
    "data-name": "Rectangle 31954",
    width: 29.675,
    height: 25.524,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31955",
    "data-name": "Rectangle 31955",
    width: 7.875,
    height: 36.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31956",
    "data-name": "Rectangle 31956",
    width: 18.657,
    height: 29.294,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31957",
    "data-name": "Rectangle 31957",
    width: 18.491,
    height: 14.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31958",
    "data-name": "Rectangle 31958",
    width: 15.406,
    height: 32.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31959",
    "data-name": "Rectangle 31959",
    width: 4.655,
    height: 7.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31960",
    "data-name": "Rectangle 31960",
    width: 4.38,
    height: 6.623,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31961",
    "data-name": "Rectangle 31961",
    width: 4.654,
    height: 7.587,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31962",
    "data-name": "Rectangle 31962",
    width: 4.379,
    height: 6.623,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31963",
    "data-name": "Rectangle 31963",
    width: 2.323,
    height: 8.212,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31964",
    "data-name": "Rectangle 31964",
    width: 2.523,
    height: 7.149,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31965",
    "data-name": "Rectangle 31965",
    width: 6.812,
    height: 6.335,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31966",
    "data-name": "Rectangle 31966",
    width: 8.065,
    height: 3.439,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31967",
    "data-name": "Rectangle 31967",
    width: 8.301,
    height: 2.542,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31968",
    "data-name": "Rectangle 31968",
    width: 6.127,
    height: 6.835,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31969",
    "data-name": "Rectangle 31969",
    width: 1.418,
    height: 6.863,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31970",
    "data-name": "Rectangle 31970",
    width: 1.418,
    height: 6.862,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31971",
    "data-name": "Rectangle 31971",
    width: 2.093,
    height: 7.473,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31972",
    "data-name": "Rectangle 31972",
    width: 3.681,
    height: 7.156,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31973",
    "data-name": "Rectangle 31973",
    width: 7.527,
    height: 1.647,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31974",
    "data-name": "Rectangle 31974",
    width: 12.167,
    height: 24.275,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31975",
    "data-name": "Rectangle 31975",
    width: 14.638,
    height: 21.592,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31976",
    "data-name": "Rectangle 31976",
    width: 10.062,
    height: 16.503,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31977",
    "data-name": "Rectangle 31977",
    width: 9.322,
    height: 15.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31978",
    "data-name": "Rectangle 31978",
    width: 5.493,
    height: 5.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31979",
    "data-name": "Rectangle 31979",
    width: 28.261,
    height: 57.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31980",
    "data-name": "Rectangle 31980",
    width: 76.036,
    height: 38.374,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31990",
    "data-name": "Rectangle 31990",
    width: 36.468,
    height: 38.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40717",
    "data-name": "Path 40717",
    d: "M471.684,186.207a1.754,1.754,0,0,0-.4-.368c.218.2.354.324.4.368",
    transform: "translate(-471.285 -185.839)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14075",
    "data-name": "Group 14075",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14070",
    "data-name": "Group 14070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14069",
    "data-name": "Group 14069",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40499",
    "data-name": "Path 40499",
    d: "M5.493,390.7h0c-3.781,0-6.429-4.673-5.18-9.14L41.1,220.2h11.63L10.673,386.1c-.77,2.756-2.848,4.6-5.18,4.6",
    transform: "translate(0 -31.069)",
    fill: "#51586b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40500",
    "data-name": "Path 40500",
    d: "M624.976,390.7h0c3.781,0,6.429-4.673,5.18-9.14L589.366,220.2h-11.63L619.8,386.1c.77,2.756,2.848,4.6,5.18,4.6",
    transform: "translate(-81.513 -31.069)",
    fill: "#51586b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31941",
    "data-name": "Rectangle 31941",
    width: 34.725,
    height: 31.044,
    transform: "translate(144.14 135.434)",
    fill: "#353b49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31942",
    "data-name": "Rectangle 31942",
    width: 34.725,
    height: 31.044,
    transform: "translate(149.574 135.434)",
    fill: "#51586b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40501",
    "data-name": "Path 40501",
    d: "M530.764,205.615V216.1a6.029,6.029,0,0,1-6.03,6.029H28.641a6.029,6.029,0,0,1-6.03-6.029V205.615a6.03,6.03,0,0,1,6.03-6.03H524.734a6.03,6.03,0,0,1,6.03,6.03",
    transform: "translate(-3.19 -28.159)",
    fill: "#51586b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40502",
    "data-name": "Path 40502",
    d: "M530.764,217.638v1.013a6.03,6.03,0,0,1-6.03,6.03H28.641a6.03,6.03,0,0,1-6.03-6.03v-1.013Z",
    transform: "translate(-3.19 -30.706)",
    fill: "#383e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40503",
    "data-name": "Path 40503",
    d: "M232.879,157.174H113.256a2.842,2.842,0,0,1-2.842-2.842V66.444a2.842,2.842,0,0,1,2.842-2.842H232.879Z",
    transform: "translate(-15.578 -8.974)",
    fill: "#353b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40504",
    "data-name": "Path 40504",
    d: "M243.187,157.174H123.067V63.6H244a1.532,1.532,0,0,1,1.531,1.532v89.7a2.345,2.345,0,0,1-2.345,2.345",
    transform: "translate(-17.363 -8.974)",
    fill: "#51586b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40719",
    "data-name": "Path 40719",
    d: "M0,0H115.527V76.184H0Z",
    transform: "translate(109.173 56.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40505",
    "data-name": "Path 40505",
    d: "M220.876,198.362H173.9c-3.36,0-6.087-3.1-6.087-6.929v-.515h48.113c2.732,0,4.947,3.333,4.947,7.444",
    transform: "translate(-23.677 -26.937)",
    fill: "#51586b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40506",
    "data-name": "Path 40506",
    d: "M220.876,198.772H173.9c-3.36,0-6.087-2.061-6.087-4.6v-.343h48.113a4.948,4.948,0,0,1,4.947,4.947",
    transform: "translate(-23.677 -27.347)",
    fill: "#353b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40507",
    "data-name": "Path 40507",
    d: "M173.251,188.011v9.941h-.828a4.606,4.606,0,0,1-4.607-4.6v-5.336Z",
    transform: "translate(-23.677 -26.526)",
    fill: "#353b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40508",
    "data-name": "Path 40508",
    d: "M359.464,122.339c.9-1.149,2.619-2.177,6.139-2.306a10.957,10.957,0,0,1,10.3,5.951,14.277,14.277,0,0,1-1.341,1.775c-.165.189-.333.365-.5.533a11.842,11.842,0,0,1-4.286,2.892c-4.77-.388-7.18-1.4-8.592-3.645a9.659,9.659,0,0,1-1-2.247,24.008,24.008,0,0,1-.715-2.953",
    transform: "translate(-50.717 -16.934)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13960",
    "data-name": "Group 13960",
    transform: "translate(308.747 103.09)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13959",
    "data-name": "Group 13959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13958",
    "data-name": "Group 13958",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40509",
    "data-name": "Path 40509",
    d: "M359.464,122.339c.9-1.149,2.619-2.177,6.139-2.306a10.957,10.957,0,0,1,10.3,5.951,14.277,14.277,0,0,1-1.341,1.775c-.165.189-.333.365-.5.533a12.591,12.591,0,0,1-6.748.688,12.171,12.171,0,0,1-7.134-3.688,24.008,24.008,0,0,1-.715-2.953",
    transform: "translate(-359.464 -120.024)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40510",
    "data-name": "Path 40510",
    d: "M370.077,137.7l3.491-26.071-3.773-.614-3.031,25.767Z",
    transform: "translate(-51.747 -15.663)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40511",
    "data-name": "Path 40511",
    d: "M364.806,137.175l2.05-26.223-3.8-.406-1.608,25.9Z",
    transform: "translate(-50.997 -15.597)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40512",
    "data-name": "Path 40512",
    d: "M380.132,100.6l-.257-22.92a1.338,1.338,0,0,0-2.641-.285L373.56,99.3Z",
    transform: "translate(-52.706 -10.773)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40513",
    "data-name": "Path 40513",
    d: "M378.527,100.3l-.215-22.941a1.36,1.36,0,0,0-.32-.868,1.338,1.338,0,0,0-.759.92L373.56,99.317Z",
    transform: "translate(-52.706 -10.792)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40514",
    "data-name": "Path 40514",
    d: "M362.223,81.486c.287-8.191,5.6-14.651,11.875-14.431s11.122,7.037,10.835,15.228-5.6,14.651-11.875,14.431-11.122-7.037-10.835-15.228",
    transform: "translate(-51.104 -9.46)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40515",
    "data-name": "Path 40515",
    d: "M362.228,81.621c.253-7.194,4.536-12.883,9.567-12.707s8.907,6.152,8.654,13.346-4.536,12.883-9.567,12.706-8.907-6.151-8.654-13.345",
    transform: "translate(-51.105 -9.723)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40516",
    "data-name": "Path 40516",
    d: "M362.474,81.634c.242-6.916,4.052-12.4,8.508-12.239s7.874,5.89,7.631,12.805-4.052,12.4-8.509,12.239-7.873-5.89-7.631-12.805",
    transform: "translate(-51.14 -9.79)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40517",
    "data-name": "Path 40517",
    d: "M358.416,117.407c-1.282-8.045,2.987-15.924,2.987-15.924l16.22,1.955s2.893,7.67.554,15.57a16.451,16.451,0,0,1-2.911,5.682l-.005.007a.6.6,0,0,1-.942-.009c-1.535-1.951-4.587-4.986-8.708-5-4.615-.016-5.2,2.195-5.1,4.36a.213.213,0,0,1-.4.107c-.088-.181-.17-.371-.246-.566l0-.007a29.735,29.735,0,0,1-1.446-6.174",
    transform: "translate(-50.535 -14.318)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13963",
    "data-name": "Group 13963",
    transform: "translate(309.316 104.536)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13962",
    "data-name": "Group 13962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13961",
    "data-name": "Group 13961",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40518",
    "data-name": "Path 40518",
    d: "M360.139,126.442l0-.007c-.1-1.567.343-4.794,5.7-4.725a11.631,11.631,0,0,1,9.7,5.835l-.005.006a.6.6,0,0,1-.942-.009c-1.535-1.951-4.587-4.986-8.708-5-4.615-.016-5.2,2.195-5.1,4.36a.213.213,0,0,1-.4.107c-.087-.181-.17-.371-.247-.566",
    transform: "translate(-360.126 -121.708)",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40519",
    "data-name": "Path 40519",
    d: "M362.914,79.61c.667-5.354,3.515-9.406,6.36-9.051s4.612,4.982,3.946,10.335-3.515,9.406-6.36,9.051-4.612-4.982-3.946-10.335",
    transform: "translate(-51.184 -9.952)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40520",
    "data-name": "Path 40520",
    d: "M369.547,100.664l-.257-22.92a1.338,1.338,0,0,0-2.641-.285l-4.715,20.488Z",
    transform: "translate(-51.065 -10.782)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40521",
    "data-name": "Path 40521",
    d: "M365.876,79.569a1.6,1.6,0,1,1,1.961,1.133,1.6,1.6,0,0,1-1.961-1.133",
    transform: "translate(-51.614 -10.942)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40522",
    "data-name": "Path 40522",
    d: "M365.55,79.681a1.485,1.485,0,1,1,1.818,1.051,1.485,1.485,0,0,1-1.818-1.051",
    transform: "translate(-51.568 -10.978)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40523",
    "data-name": "Path 40523",
    d: "M365.551,79.741a1.195,1.195,0,1,1,1.463.845,1.2,1.2,0,0,1-1.463-.845",
    transform: "translate(-51.57 -11.039)",
    fill: "#32cdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40524",
    "data-name": "Path 40524",
    d: "M372.75,125.421s4.339,2.456,17.34,1.943c12.963-.511,17.081-3.3,17.081-3.3l-.513-13.025L372.237,112.4Z",
    transform: "translate(-52.519 -15.667)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40525",
    "data-name": "Path 40525",
    d: "M372.333,113.913s4.077,4.779,17.431,4.253c13.2-.52,16.99-5.609,16.99-5.609l.059-17.124-34.939,6.831Z",
    transform: "translate(-52.468 -13.465)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40526",
    "data-name": "Path 40526",
    d: "M372.966,111.94a50.689,50.689,0,0,0,32.6-1.283,2.914,2.914,0,0,0,1.852-3.848,3.062,3.062,0,0,0-3.88-1.427,45.039,45.039,0,0,1-28.966,1.141,3.062,3.062,0,0,0-3.756,1.727,2.916,2.916,0,0,0,2.149,3.69",
    transform: "translate(-52.296 -14.838)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40527",
    "data-name": "Path 40527",
    d: "M389.681,111.933a48.123,48.123,0,0,0,15.405-3.174c.4-.155.51-.434.505-.5a.565.565,0,0,0-.512-.218.8.8,0,0,0-.253.052,47.508,47.508,0,0,1-30.551,1.2.78.78,0,0,0-.253-.031.551.551,0,0,0-.5.274.749.749,0,0,0,.545.441,48.134,48.134,0,0,0,15.609,1.953",
    transform: "translate(-52.701 -15.243)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40528",
    "data-name": "Path 40528",
    d: "M389.629,110.619a48.123,48.123,0,0,0,15.405-3.174c.4-.155.51-.434.505-.5a.565.565,0,0,0-.512-.218.8.8,0,0,0-.253.052,47.507,47.507,0,0,1-30.551,1.2.783.783,0,0,0-.253-.031.551.551,0,0,0-.5.274.749.749,0,0,0,.545.441,48.135,48.135,0,0,0,15.609,1.953",
    transform: "translate(-52.694 -15.058)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40529",
    "data-name": "Path 40529",
    d: "M371.363,120.027a60.962,60.962,0,0,0,35.836-1.411c1.885-.663,2.782-2.45,2.051-3.855a3.5,3.5,0,0,0-4.259-1.412A54.173,54.173,0,0,1,373.15,114.6a3.5,3.5,0,0,0-4.135,1.742c-.618,1.458.417,3.169,2.347,3.682",
    transform: "translate(-52.039 -15.961)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40530",
    "data-name": "Path 40530",
    d: "M389.766,119.956a58.17,58.17,0,0,0,17.088-3.261l.011,0a.356.356,0,0,0-.13-.687h-.029a1.416,1.416,0,0,0-.421.079,56.633,56.633,0,0,1-33.3,1.31,1.466,1.466,0,0,0-.423-.046l-.03,0a.356.356,0,0,0-.076.7l.012,0a58.177,58.177,0,0,0,17.292,1.908",
    transform: "translate(-52.515 -16.367)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40531",
    "data-name": "Path 40531",
    d: "M389.68,117.787a58.17,58.17,0,0,0,17.088-3.261l.011,0a.356.356,0,0,0-.13-.687h-.029a1.416,1.416,0,0,0-.421.079,56.633,56.633,0,0,1-33.3,1.31,1.467,1.467,0,0,0-.423-.046l-.03,0a.356.356,0,0,0-.076.7l.012,0a58.176,58.176,0,0,0,17.292,1.908",
    transform: "translate(-52.503 -16.061)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40532",
    "data-name": "Path 40532",
    d: "M380.624,257.284a4.827,4.827,0,0,1,2.365,1.119l6.549,5.8-3.809,7.873a4.826,4.826,0,0,1-1.75,1.945s-20.136,10.206-27.286,12.527c-5.214,1.693-21.512,4.313-21.512,4.313s-8.049-5.775-9.662-13.823,3.588-16.479,3.588-16.479,16.048-3.865,21.511-4.312c7.492-.613,30.007,1.042,30.007,1.042",
    transform: "translate(-45.883 -36.134)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40533",
    "data-name": "Path 40533",
    d: "M380.1,254.69a4.827,4.827,0,0,1,2.365,1.119l6.549,5.8-3.809,7.872a4.826,4.826,0,0,1-1.75,1.945s-20.136,10.206-27.286,12.527c-5.214,1.693-21.512,4.313-21.512,4.313s-8.049-5.775-9.662-13.823,3.588-16.479,3.588-16.479,16.048-3.865,21.511-4.312c7.492-.613,30.007,1.042,30.007,1.042",
    transform: "translate(-45.81 -35.768)",
    fill: "#616364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40534",
    "data-name": "Path 40534",
    d: "M399.387,262.935l.447,2.227-.82,1.7-.829-1.438Z",
    transform: "translate(-56.18 -37.097)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40535",
    "data-name": "Path 40535",
    d: "M323.475,250.806a20.572,20.572,0,1,0,24.214,16.128,20.572,20.572,0,0,0-24.214-16.128",
    transform: "translate(-43.306 -35.329)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40536",
    "data-name": "Path 40536",
    d: "M323.822,251.909A19.61,19.61,0,1,0,346.9,267.281a19.61,19.61,0,0,0-23.081-15.373",
    transform: "translate(-43.465 -35.487)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40537",
    "data-name": "Path 40537",
    d: "M324.7,254.677a17.191,17.191,0,1,0,20.233,13.476A17.19,17.19,0,0,0,324.7,254.677",
    transform: "translate(-43.862 -35.885)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40538",
    "data-name": "Path 40538",
    d: "M379.506,251.705a4.827,4.827,0,0,1,2.365,1.119l6.549,5.8-3.809,7.873a4.826,4.826,0,0,1-1.75,1.945s-20.136,10.206-27.286,12.527c-5.214,1.693-21.512,4.313-21.512,4.313s-8.049-5.775-9.662-13.823,3.588-16.479,3.588-16.479,16.048-3.865,21.511-4.312c7.492-.613,30.007,1.042,30.007,1.042",
    transform: "translate(-45.726 -35.347)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40539",
    "data-name": "Path 40539",
    d: "M378.986,249.112a4.827,4.827,0,0,1,2.365,1.119l6.549,5.8L384.09,263.9a4.825,4.825,0,0,1-1.75,1.945S362.2,276.05,355.054,278.372c-5.214,1.693-21.512,4.313-21.512,4.313s-8.049-5.775-9.662-13.823,3.588-16.479,3.588-16.479,16.048-3.865,21.511-4.312c7.492-.613,30.007,1.042,30.007,1.042",
    transform: "translate(-45.652 -34.981)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40540",
    "data-name": "Path 40540",
    d: "M398.269,257.357l.447,2.227-.82,1.7-.829-1.438Z",
    transform: "translate(-56.022 -36.31)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40541",
    "data-name": "Path 40541",
    d: "M215.44,335.916l46.932,44.847,9.071-14.282L277.4,357.1l7.159-11.27-36.73-35.669-6.785,5.394L236.33,319.3Z",
    transform: "translate(-30.396 -43.76)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40542",
    "data-name": "Path 40542",
    d: "M206.962,316.256l2.926,10.155L195.806,343.2l5.4,5.246s14.706-15.995,14.865-16.159,1.757-7.77,1.757-7.77l-4.689-4.934-2.463-1.327Z",
    transform: "translate(-27.626 -44.62)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40543",
    "data-name": "Path 40543",
    d: "M211.172,318.587l3.974,6.389-4.94,10.244-10.9,11.228,2.4,2.329s14.707-16,14.866-16.159,1.757-7.771,1.757-7.771l-4.689-4.934Z",
    transform: "translate(-28.12 -44.949)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40544",
    "data-name": "Path 40544",
    d: "M271.58,385.829l-3.729,4.871-40.188-39.3-4.042-25.933,5.707,2.933,10.921,26.253Z",
    transform: "translate(-31.551 -45.92)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13966",
    "data-name": "Group 13966",
    transform: "translate(205.933 271.793)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13965",
    "data-name": "Group 13965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13964",
    "data-name": "Group 13964",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40545",
    "data-name": "Path 40545",
    d: "M239.761,320.19l7.7,20.558,27.412,26.619,5.959-9.384-36.357-41.544Z",
    transform: "translate(-239.761 -316.439)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40546",
    "data-name": "Path 40546",
    d: "M239.715,310.811l5.639,14.885.548,1.445,2.515,6.646-1,.382-.445.169,11.351,11.023,1.16-1.195,17.634,17.125,42.184-59.82-.009-.009c5.118-5.847,3.007-16.546-4.89-24.214a27.735,27.735,0,0,0-5.6-4.223c-.443-.255-.892-.493-1.343-.714-6.449-3.184-13.265-3.083-17.408.759l-.008-.008L239.73,310.8l-.015.012",
    transform: "translate(-33.821 -38.101)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40547",
    "data-name": "Path 40547",
    d: "M228.569,324.985l14.6,14.183-7.462-19.541Z",
    transform: "translate(-32.249 -45.096)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40548",
    "data-name": "Path 40548",
    d: "M232.928,349.149l40.359,39.193,2.06-3.064-.678-12.99-18.742-18.2.827-.852L245.4,342.214l-1.224.467-1-2.633-14.606-14.182Z",
    transform: "translate(-32.249 -45.976)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40549",
    "data-name": "Path 40549",
    d: "M212.177,318.3l4.38,7.06-5.073,10.626-12.466,13.034,57.967,56.292,10.437-15.514-41.173-39.983-5.06-26.722Z",
    transform: "translate(-28.079 -44.908)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40550",
    "data-name": "Path 40550",
    d: "M166.862,321.516l25.879,25.132,11.352-11.69,5.422-11.106-5.111-7.956-4.55-2.419Z",
    transform: "translate(-23.543 -44.229)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13969",
    "data-name": "Group 13969",
    transform: "translate(205.894 231.944)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13968",
    "data-name": "Group 13968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13967",
    "data-name": "Group 13967",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40551",
    "data-name": "Path 40551",
    d: "M239.715,310.811l5.639,14.885,62.112-53.386c-6.449-3.184-13.265-3.083-17.408.759l-.008-.008L239.73,310.8l-.015.012",
    transform: "translate(-239.715 -270.044)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40552",
    "data-name": "Path 40552",
    d: "M249.433,334.275l-1,.382.551,1.137,10.355,10.055,1.159-1.194,17.634,17.124,42.184-59.821-.009-.009c5.118-5.847,3.007-16.545-4.89-24.214a27.727,27.727,0,0,0-5.6-4.224l-62.908,54.116Z",
    transform: "translate(-34.838 -38.59)",
    fill: "#cacccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40553",
    "data-name": "Path 40553",
    d: "M246.935,343.655a9.548,9.548,0,1,0,13.5-.2,9.548,9.548,0,0,0-13.5.2",
    transform: "translate(-34.459 -48.078)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40554",
    "data-name": "Path 40554",
    d: "M248.527,345.209a7.742,7.742,0,1,0,10.947-.16,7.741,7.741,0,0,0-10.947.16",
    transform: "translate(-34.756 -48.374)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40555",
    "data-name": "Path 40555",
    d: "M249.909,346.56a6.173,6.173,0,1,0,8.729-.128,6.173,6.173,0,0,0-8.729.128",
    transform: "translate(-35.014 -48.632)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40556",
    "data-name": "Path 40556",
    d: "M270.632,388.083,231.5,349.948l-3.93-22.447,1.238.636,3.977,21.243,38.7,37.583Z",
    transform: "translate(-32.108 -46.207)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40557",
    "data-name": "Path 40557",
    d: "M250.214,401.612l1.41,1.37,8.142-4.919,4.678-8.282-1.41-1.37-4.678,8.283Z",
    transform: "translate(-35.303 -54.801)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40558",
    "data-name": "Path 40558",
    d: "M264.181,389.525l.426.413-4.678,8.282-8.142,4.919-.426-.413,8.142-4.919Z",
    transform: "translate(-35.464 -54.958)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40559",
    "data-name": "Path 40559",
    d: "M217.219,369.57l-1.41-1.37,4.678-8.283L228.628,355l1.411,1.369-8.142,4.919Z",
    transform: "translate(-30.448 -50.087)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40560",
    "data-name": "Path 40560",
    d: "M229.054,355.412l-.426-.413-8.142,4.918-4.678,8.283.425.414,4.678-8.283Z",
    transform: "translate(-30.448 -50.087)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40561",
    "data-name": "Path 40561",
    d: "M373.675,203.531s-4.572-3.131-6.818-6.931,6.665-1.035,7.612,1.291-.794,5.64-.794,5.64",
    transform: "translate(-51.709 -27.473)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40562",
    "data-name": "Path 40562",
    d: "M376.545,199.616l1.741,22.42.125,1.613,1.028,13.232.125,1.613.034.436s3.737,2.115,14.924,1.674c11.157-.442,14.7-2.84,14.7-2.84l1.591-33.461Z",
    transform: "translate(-53.127 -28.164)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40563",
    "data-name": "Path 40563",
    d: "M375.027,212.671a61.823,61.823,0,0,1,34.782,2.706,1.476,1.476,0,0,0,1.94-.971q1.035-3.582,2.069-7.162a1.473,1.473,0,0,0-.876-1.787,68.69,68.69,0,0,0-39.475-3.073,1.474,1.474,0,0,0-1.142,1.629q.468,3.7.936,7.4a1.475,1.475,0,0,0,1.766,1.26",
    transform: "translate(-52.53 -28.332)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13972",
    "data-name": "Group 13972",
    transform: "translate(319.783 172.477)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13971",
    "data-name": "Group 13971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13970",
    "data-name": "Group 13970",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40564",
    "data-name": "Path 40564",
    d: "M413.808,207.279a1.462,1.462,0,0,0-.917-1.172,68.694,68.694,0,0,0-39.474-3.072,1.462,1.462,0,0,0-1.087,1.016c0-.013,0-.025,0-.038a1.474,1.474,0,0,1,1.142-1.629,68.7,68.7,0,0,1,39.475,3.072,1.474,1.474,0,0,1,.876,1.787l-.01.036",
    transform: "translate(-372.312 -200.809)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40565",
    "data-name": "Path 40565",
    d: "M378.573,225.719l.125,1.613,1.027,13.232.125,1.613c2.92-.885,5.008-4.342,4.849-8.385-.17-4.323-2.853-7.781-6.127-8.073",
    transform: "translate(-53.413 -31.847)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40566",
    "data-name": "Path 40566",
    d: "M378.718,227.6l1.028,13.232c2.267-.8,3.866-3.539,3.741-6.724-.134-3.415-2.2-6.159-4.769-6.509",
    transform: "translate(-53.433 -32.112)",
    fill: "#45d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40567",
    "data-name": "Path 40567",
    d: "M377.345,225.764a56.623,56.623,0,0,1,31.858,2.479,1.351,1.351,0,0,0,1.776-.891l1.9-6.56a1.35,1.35,0,0,0-.8-1.636,62.917,62.917,0,0,0-36.156-2.814,1.351,1.351,0,0,0-1.046,1.493l.858,6.773a1.352,1.352,0,0,0,1.617,1.155",
    transform: "translate(-52.889 -30.32)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13975",
    "data-name": "Group 13975",
    transform: "translate(321.97 184.58)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13974",
    "data-name": "Group 13974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13973",
    "data-name": "Group 13973",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40568",
    "data-name": "Path 40568",
    d: "M412.865,220.826a1.337,1.337,0,0,0-.84-1.073,62.915,62.915,0,0,0-36.155-2.814,1.339,1.339,0,0,0-1,.93c0-.011,0-.023,0-.034a1.352,1.352,0,0,1,1.047-1.493,62.922,62.922,0,0,1,36.155,2.814,1.35,1.35,0,0,1,.8,1.636l-.009.034",
    transform: "translate(-374.859 -214.9)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40569",
    "data-name": "Path 40569",
    d: "M379.689,238.585a51.311,51.311,0,0,1,28.874,2.247,1.226,1.226,0,0,0,1.61-.807q.859-2.972,1.718-5.945a1.224,1.224,0,0,0-.727-1.483,57.027,57.027,0,0,0-32.77-2.55,1.224,1.224,0,0,0-.948,1.353q.389,3.07.777,6.139a1.226,1.226,0,0,0,1.466,1.047",
    transform: "translate(-53.252 -32.273)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13978",
    "data-name": "Group 13978",
    transform: "translate(324.183 196.465)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13977",
    "data-name": "Group 13977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13976",
    "data-name": "Group 13976",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40570",
    "data-name": "Path 40570",
    d: "M411.882,234.11a1.214,1.214,0,0,0-.761-.972,57.02,57.02,0,0,0-32.77-2.55,1.213,1.213,0,0,0-.9.843c0-.01,0-.021,0-.031a1.224,1.224,0,0,1,.948-1.353,57.035,57.035,0,0,1,32.77,2.55,1.224,1.224,0,0,1,.727,1.483l-.009.03",
    transform: "translate(-377.435 -228.738)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40571",
    "data-name": "Path 40571",
    d: "M347.8,154.382a57.916,57.916,0,0,0,.63,6.806c.241,1.633.528,3.274.834,4.917,3.588,19.138,15.992,20.464,15.992,20.464s4.167,3.214,5.778,6.716c4.521,1.464,43.051,5.061,43.051,5.061a28.769,28.769,0,0,0,4.753-4.053A43.985,43.985,0,0,0,428.418,179c.18-.478.354-.969.525-1.466a.068.068,0,0,1,.007-.025,55.338,55.338,0,0,0,2.685-20.034c-.262-6.668-3.824-21.085-6.162-28.871a9.127,9.127,0,0,0-9.1-6.5l-48.333,1.9a16.8,16.8,0,0,0-5.27,1.074,15.53,15.53,0,0,0-6.576,4.64c-.722.885-1.984,2.681-2.616,3.6-4.46,6.464-6,13.533-5.774,21.058",
    transform: "translate(-49.068 -17.228)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13981",
    "data-name": "Group 13981",
    transform: "translate(299.362 143.96)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13980",
    "data-name": "Group 13980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13979",
    "data-name": "Group 13979",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40572",
    "data-name": "Path 40572",
    d: "M348.537,167.608c.241,1.633.529,3.274.835,4.917,3.587,19.138,15.991,20.464,15.991,20.464s4.167,3.214,5.778,6.716c4.522,1.464,43.051,5.061,43.051,5.061a28.769,28.769,0,0,0,4.753-4.053h0c-23.084,2.8-18.122-16.86-18.122-16.86s-24.506-2.117-29.989-9.027-22.295-7.217-22.295-7.217",
    transform: "translate(-348.537 -167.608)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13984",
    "data-name": "Group 13984",
    transform: "translate(358.544 104.876)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13983",
    "data-name": "Group 13983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13982",
    "data-name": "Group 13982",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40573",
    "data-name": "Path 40573",
    d: "M437.79,146.688c2.994,19.361,1.806,27.764.988,30.823a55.322,55.322,0,0,0,2.686-20.034c-.263-6.668-3.825-21.085-6.162-28.871a9.13,9.13,0,0,0-9.1-6.5l-8.757.345c3.528.019,16.85,1.606,20.349,24.233",
    transform: "translate(-417.441 -122.103)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40574",
    "data-name": "Path 40574",
    d: "M362.466,258.139c.1,6.334,12.147,21.951,12.147,21.951s.648-.026,1.72-.058c3.184-.1,10.187-.152,15.821-.771,4.895-.538,13.689-3.583,19.418-5.719l0,0c3.25-1.21,5.512-2.129,5.512-2.129l2.363-24.127a10.4,10.4,0,0,0-7.7-9.886l-.03-.008a10.388,10.388,0,0,0-2.823-.344l-36.319.552s-10.328,6.111-10.109,20.541",
    transform: "translate(-51.14 -33.445)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40575",
    "data-name": "Path 40575",
    d: "M369.053,158.694a24.249,24.249,0,1,0,23.276-25.184,24.248,24.248,0,0,0-23.276,25.184",
    transform: "translate(-52.067 -18.834)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40576",
    "data-name": "Path 40576",
    d: "M380.982,159.976a14,14,0,1,0,13.434-14.535,14,14,0,0,0-13.434,14.535",
    transform: "translate(-53.751 -20.519)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13987",
    "data-name": "Group 13987",
    transform: "translate(311.323 204.041)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13986",
    "data-name": "Group 13986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13985",
    "data-name": "Group 13985",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40577",
    "data-name": "Path 40577",
    d: "M362.466,258.211c.1,6.334,12.147,21.951,12.147,21.951s.648-.026,1.72-.058c0,0-9.586-16.778-8.948-22.436.905-8.023,10.829-18.236,12.573-20.11l-7.382.113s-10.328,6.111-10.109,20.541",
    transform: "translate(-362.463 -237.558)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40578",
    "data-name": "Path 40578",
    d: "M382.754,262.32A15.1,15.1,0,1,0,397.619,247a15.1,15.1,0,0,0-14.865,15.324",
    transform: "translate(-54.002 -34.848)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40579",
    "data-name": "Path 40579",
    d: "M382.754,262.32A15.1,15.1,0,1,0,397.619,247a15.1,15.1,0,0,0-14.865,15.324",
    transform: "translate(-54.002 -34.848)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40580",
    "data-name": "Path 40580",
    d: "M380.11,262.359a15.035,15.035,0,0,0,.808,4.659,14.381,14.381,0,0,0,.682,1.668,15.1,15.1,0,1,0,26.378-14.606,15.254,15.254,0,0,0-3.582-3.927,15.028,15.028,0,0,0-8.464-3.1c-.316-.014-.636-.02-.957-.015a15.1,15.1,0,0,0-14.8,13.7,15.406,15.406,0,0,0-.061,1.623",
    transform: "translate(-53.629 -34.854)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13990",
    "data-name": "Group 13990",
    transform: "translate(326.479 212.196)",
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13989",
    "data-name": "Group 13989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13988",
    "data-name": "Group 13988",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40581",
    "data-name": "Path 40581",
    d: "M381.845,269.843a14.982,14.982,0,0,0,2.708,3.889l25.475-14.377a15.058,15.058,0,0,0-1.805-4.118Z",
    transform: "translate(-380.353 -248.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40582",
    "data-name": "Path 40582",
    d: "M380.11,262.361a15.035,15.035,0,0,0,.808,4.659L404.4,250.155a15.029,15.029,0,0,0-8.464-3.1l-15.761,13.685a15.4,15.4,0,0,0-.061,1.623",
    transform: "translate(-380.108 -247.053)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40583",
    "data-name": "Path 40583",
    d: "M383.98,262.855a11.771,11.771,0,1,0,11.591-11.948,11.771,11.771,0,0,0-11.591,11.948",
    transform: "translate(-54.175 -35.4)",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13993",
    "data-name": "Group 13993",
    transform: "translate(360.436 203.945)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13992",
    "data-name": "Group 13992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13991",
    "data-name": "Group 13991",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40584",
    "data-name": "Path 40584",
    d: "M419.643,273.6c3.25-1.21,5.513-2.129,5.513-2.129l2.363-24.127a10.4,10.4,0,0,0-7.7-9.886l-.03-.008s5.759,4.02,5.684,11.14c-.072,7.063-5.74,24.732-5.827,25.01",
    transform: "translate(-419.643 -237.446)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13996",
    "data-name": "Group 13996",
    transform: "translate(298.711 107.86)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13995",
    "data-name": "Group 13995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13994",
    "data-name": "Group 13994",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40585",
    "data-name": "Path 40585",
    d: "M347.8,154.872c1.8-7.83,5.225-17.623,9.09-22.012a21.9,21.9,0,0,1,9.547-6.444,4.8,4.8,0,0,1-3.671-.837,15.53,15.53,0,0,0-6.576,4.64c-.722.885-1.984,2.681-2.616,3.6-4.46,6.464-6,13.533-5.774,21.058",
    transform: "translate(-347.779 -125.578)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40586",
    "data-name": "Path 40586",
    d: "M383.067,160.2a12.2,12.2,0,1,0,11.713-12.673A12.2,12.2,0,0,0,383.067,160.2",
    transform: "translate(-54.046 -20.813)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40587",
    "data-name": "Path 40587",
    d: "M363.643,99.847s-5.14-7.727-8.149-9.054-7.666,4.158-8.183,4.076,2.605-9.68,6.334-10.964,12.43,3.259,12.976,5.506-2.978,10.437-2.978,10.437",
    transform: "translate(-48.994 -11.806)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40588",
    "data-name": "Path 40588",
    d: "M348.4,93.949s4.014-5.924,7.317-5.584,5.756,8.228,7.354,10.241,4.212-.415,3.771-3.828-8.039-11.4-12.1-10.183-6.339,9.354-6.339,9.354",
    transform: "translate(-49.155 -11.918)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13999",
    "data-name": "Group 13999",
    transform: "translate(299.384 71.866)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13998",
    "data-name": "Group 13998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13997",
    "data-name": "Group 13997",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40589",
    "data-name": "Path 40589",
    d: "M348.563,93.15s4.014-5.924,7.317-5.584,5.756,8.228,7.354,10.241,4.212-.415,3.771-3.828-8.039-11.4-12.1-10.183-6.339,9.354-6.339,9.354",
    transform: "translate(-348.563 -83.671)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40590",
    "data-name": "Path 40590",
    d: "M373.857,18.1c-2.35,10.972,10.269,22.977,28.186,26.814S436.39,42.974,438.74,32,428.471,9.027,410.554,5.188s-34.347,1.945-36.7,12.916",
    transform: "translate(-52.708 -0.565)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40591",
    "data-name": "Path 40591",
    d: "M381.212,9.236c6.861-4.837,18.3-6.644,30.419-4.047,11.016,2.359,20.026,7.807,24.789,14.2A97.4,97.4,0,0,0,410.8,10.161c-11.194-2.4-18.3-2.057-27.67-.862a6.518,6.518,0,0,1-1.92-.062",
    transform: "translate(-53.785 -0.565)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40592",
    "data-name": "Path 40592",
    d: "M378.932,6.97a.326.326,0,0,0,.1.572,8.252,8.252,0,0,0,3.886.612c9.372-1.195,16.476-1.536,27.669.861A95.12,95.12,0,0,1,439.34,20.028a.407.407,0,0,0,.592-.528c-5.326-8.727-15.291-15.769-27.648-18.416a46.023,46.023,0,0,0-21.655.426,36.382,36.382,0,0,0-11.7,5.46",
    transform: "translate(-53.445 0)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40593",
    "data-name": "Path 40593",
    d: "M367.021,25.353c-.059.275-.112.551-.163.826-2.82,15.862,10.812,31.992,30.884,36.292,20.421,4.374,39.773-5.153,43.226-21.278a25.575,25.575,0,0,0-2.833-17.712,92.151,92.151,0,0,0-29.55-11.633C397.612,9.5,390.65,9.833,381.461,11a8.709,8.709,0,0,1-4.368-.82q-.773.575-1.5,1.192l0,0v0a25.581,25.581,0,0,0-7.914,11.541c-.055.167-.109.331-.156.5-.027.09-.056.183-.081.274-.162.543-.3,1.1-.421,1.659",
    transform: "translate(-51.708 -1.425)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40594",
    "data-name": "Path 40594",
    d: "M367.6,23.9c9.179,1.613,52.36,6.16,53.76,6.307-1.211-.2-33.863-5.546-41.931-8.925-8.089-3.386-3.819-9.5-3.678-9.7a25.6,25.6,0,0,0-7.915,11.541c-.055.167-.109.331-.155.5-.027.09-.056.182-.081.273",
    transform: "translate(-51.864 -1.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40595",
    "data-name": "Path 40595",
    d: "M354.3,54.177c-1,4.66-1.862,9.579-2.567,14.637-.04.257-.076.515-.111.774l-.169,1.225L365.7,74.728c.094.026.188.049.283.069a4.581,4.581,0,0,0,5.535-3.346L377.3,44.463a4.582,4.582,0,0,0-3.679-5.32c-.095-.021-.19-.038-.286-.053l-13.749-2.131-.428,1.03c-.12.289-.239.582-.356.875a92.859,92.859,0,0,0-4.5,15.313",
    transform: "translate(-49.587 -5.215)",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40596",
    "data-name": "Path 40596",
    d: "M348.518,84.874c10.31-16.786,12.853,5.671,15.539,7.068,5.725,2.979,10.643,3.585,26.586,4.826a96.617,96.617,0,0,0,11.393.247l.006,0c17.989-.722,25.127-6.842,25.127-6.842s9.873-10.407,13.043-25.2a105.985,105.985,0,0,0,1.352-23.231,13.763,13.763,0,0,0-.269-1.881l0,0c-.559-2.56-1.929-4.726-4.714-5.322l-6.421-.844-62.217-8.179-.912-.119c-3.45-.739-6.129,1.506-7.5,4.531-.282.623-.57,1.244-.87,1.876-.4.854-.818,1.727-1.244,2.656a1.04,1.04,0,0,0,.846,1.427l10.224,1.584c.09.014.182.031.271.05a4.362,4.362,0,0,1,3.5,5.062l-5.5,25.661a4.362,4.362,0,0,1-5.266,3.185c-.089-.019-.18-.041-.269-.066l-10.955-3.012a1.074,1.074,0,0,0-1.347.832c-.844,3.93-4.807,22.878-.4,15.7",
    transform: "translate(-48.884 -3.562)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40597",
    "data-name": "Path 40597",
    d: "M381.678,59.8a18.232,18.232,0,1,0,21.646-14.009A18.232,18.232,0,0,0,381.678,59.8",
    transform: "translate(-53.793 -6.403)",
    fill: "#cacccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40598",
    "data-name": "Path 40598",
    d: "M382.771,60.158a17.275,17.275,0,1,0,20.51-13.274,17.275,17.275,0,0,0-20.51,13.274",
    transform: "translate(-53.951 -6.56)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40599",
    "data-name": "Path 40599",
    d: "M383.356,60.35a16.763,16.763,0,1,0,19.9-12.88,16.763,16.763,0,0,0-19.9,12.88",
    transform: "translate(-54.035 -6.645)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40600",
    "data-name": "Path 40600",
    d: "M386.17,61.271a14.3,14.3,0,1,0,16.976-10.986A14.3,14.3,0,0,0,386.17,61.271",
    transform: "translate(-54.44 -7.049)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40601",
    "data-name": "Path 40601",
    d: "M386.641,61.425a13.887,13.887,0,1,0,16.488-10.67,13.887,13.887,0,0,0-16.488,10.67",
    transform: "translate(-54.507 -7.117)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40602",
    "data-name": "Path 40602",
    d: "M387.735,61.783a12.928,12.928,0,1,0,15.35-9.933,12.928,12.928,0,0,0-15.35,9.933",
    transform: "translate(-54.665 -7.275)",
    fill: "#cacccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40603",
    "data-name": "Path 40603",
    d: "M388.631,62.077a12.144,12.144,0,1,0,14.419-9.331,12.144,12.144,0,0,0-14.419,9.331",
    transform: "translate(-54.794 -7.404)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40604",
    "data-name": "Path 40604",
    d: "M396.761,64.007c-1.119,5.225-2.466,9.366,2.759,10.485a9.675,9.675,0,1,0,4.052-18.92c-5.225-1.119-5.692,3.211-6.811,8.435",
    transform: "translate(-55.834 -7.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40605",
    "data-name": "Path 40605",
    d: "M354.347,54.49c-1,4.66-1.862,9.579-2.566,14.637l5.4,1.486,5.154,1.416A2.987,2.987,0,0,0,366.11,69.9l5.5-25.662a2.986,2.986,0,0,0-2.572-3.487l-1.926-.3-8.259-1.278a92.862,92.862,0,0,0-4.5,15.313",
    transform: "translate(-49.633 -5.527)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14002",
    "data-name": "Group 14002",
    transform: "translate(306.629 34.218)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14001",
    "data-name": "Group 14001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14000",
    "data-name": "Group 14000",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40606",
    "data-name": "Path 40606",
    d: "M357.918,70.706l5.154,1.416a2.987,2.987,0,0,0,3.775-2.128l5.5-25.661a2.986,2.986,0,0,0-2.572-3.487l-1.925-.3-7.743-.71s-5.149,21.993-2.185,30.867",
    transform: "translate(-356.998 -39.839)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40607",
    "data-name": "Path 40607",
    d: "M362.263,71.192c.048.013.1.025.148.035a2.309,2.309,0,0,0,2.863-1.506l5.5-25.661a2.309,2.309,0,0,0-1.994-2.547l-.151-.028-10.046-1.621c.09-.23.18-.46.271-.688l10.185,1.575a2.986,2.986,0,0,1,2.573,3.487L366.11,69.9a2.987,2.987,0,0,1-3.775,2.128l-10.554-2.9c.034-.24.069-.478.1-.716Z",
    transform: "translate(-49.633 -5.527)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40608",
    "data-name": "Path 40608",
    d: "M411.172,98.4c17.989-.722,25.127-6.843,25.127-6.843s9.873-10.407,13.043-25.2a105.994,105.994,0,0,0,1.352-23.232,13.889,13.889,0,0,0-.269-1.88l0,0c-.559-2.56-1.929-4.726-4.714-5.323l-6.421-.843s12,4.112,8.534,22.9-12.193,36.75-36.65,40.427",
    transform: "translate(-58.012 -4.948)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40609",
    "data-name": "Path 40609",
    d: "M252.954,193.36s-10.206-1.966-13.226-2.1-11.23-2.9-11.21-3.383,1.2-4.358,2.529-4.7,9.2,3.255,10.471,3.553,8.879-.4,9.714.3,1.721,6.335,1.721,6.335",
    transform: "translate(-32.242 -25.841)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40610",
    "data-name": "Path 40610",
    d: "M250.771,188.027a35.751,35.751,0,0,0-5.254-.07,22.108,22.108,0,0,1-4.045-.058,1.815,1.815,0,0,1-.886-.543c-.746-.769-3.648-1-5.483-1.745a19.431,19.431,0,0,0-3.627-1.26c-.5.272-1.29,2.157-1.61,3.228,1.769.8,7.7,2.719,10.1,2.824,1.665.072,6.669,1.641,11.946,2.017a21.71,21.71,0,0,0-1.138-4.392",
    transform: "translate(-32.432 -26.01)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40611",
    "data-name": "Path 40611",
    d: "M243.139,193.82s3.487-7.155,3.169-7.482c-.115-.119-.53-.088-1.031-.018a6.259,6.259,0,0,1-2.493-.155l-3.452-.879s-2.971,5.616-2.493,6.077a11.864,11.864,0,0,0,2.408,1.063c.3.148,1.452.643,2.426,1.008.764.281,1.417.485,1.464.387",
    transform: "translate(-33.408 -26.142)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14005",
    "data-name": "Group 14005",
    transform: "translate(208.265 160.116)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14004",
    "data-name": "Group 14004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14003",
    "data-name": "Group 14003",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40612",
    "data-name": "Path 40612",
    d: "M243.941,193.98s3.487-7.155,3.169-7.482c-.115-.119-.53-.088-1.031-.018a68.516,68.516,0,0,1-3.6,7.113c.764.281,1.417.485,1.464.387",
    transform: "translate(-242.476 -186.418)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40613",
    "data-name": "Path 40613",
    d: "M233.863,183.5a1.666,1.666,0,0,0-.612-.618,30.761,30.761,0,0,0-5.038-2.512c-2.913-.681-5.663,3.107-3.931,4.95a59.328,59.328,0,0,0,5.205,3.612,5.429,5.429,0,0,0,1.026.573,34.393,34.393,0,0,0,3.35-6",
    transform: "translate(-31.568 -25.437)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14008",
    "data-name": "Group 14008",
    transform: "translate(197.919 157.446)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14007",
    "data-name": "Group 14007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14006",
    "data-name": "Group 14006",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40614",
    "data-name": "Path 40614",
    d: "M234.806,183.927a1.666,1.666,0,0,0-.612-.618,19.373,19.373,0,0,1-3.765,6.049,5.43,5.43,0,0,0,1.026.573,34.393,34.393,0,0,0,3.35-6",
    transform: "translate(-230.43 -183.309)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40615",
    "data-name": "Path 40615",
    d: "M251.716,207.555s-10.206-1.966-13.226-2.1-11.23-2.9-11.21-3.383,1.2-4.358,2.53-4.7,9.2,3.255,10.471,3.553,8.879-.4,9.714.3,1.721,6.335,1.721,6.335",
    transform: "translate(-32.067 -27.843)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40616",
    "data-name": "Path 40616",
    d: "M249.533,202.222a35.759,35.759,0,0,0-5.254-.07,22.111,22.111,0,0,1-4.045-.058,1.815,1.815,0,0,1-.886-.543c-.746-.769-3.649-1-5.483-1.745a19.414,19.414,0,0,0-3.628-1.26c-.5.272-1.29,2.157-1.609,3.228,1.77.8,7.695,2.719,10.1,2.824,1.665.072,6.669,1.641,11.947,2.017a21.709,21.709,0,0,0-1.138-4.392",
    transform: "translate(-32.257 -28.013)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40617",
    "data-name": "Path 40617",
    d: "M241.9,208.015s3.487-7.155,3.169-7.482c-.115-.119-.53-.088-1.031-.018a6.259,6.259,0,0,1-2.493-.155l-3.452-.879s-2.971,5.616-2.493,6.077a11.866,11.866,0,0,0,2.408,1.063c.3.148,1.452.643,2.426,1.007.764.281,1.417.485,1.464.387",
    transform: "translate(-33.233 -28.145)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14011",
    "data-name": "Group 14011",
    transform: "translate(207.202 172.309)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14010",
    "data-name": "Group 14010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14009",
    "data-name": "Group 14009",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40618",
    "data-name": "Path 40618",
    d: "M242.7,208.175s3.487-7.155,3.169-7.482c-.115-.118-.53-.088-1.031-.018a68.525,68.525,0,0,1-3.6,7.113c.764.281,1.417.485,1.464.387",
    transform: "translate(-241.238 -200.613)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40619",
    "data-name": "Path 40619",
    d: "M232.625,197.7a1.667,1.667,0,0,0-.612-.618,30.761,30.761,0,0,0-5.038-2.512c-2.913-.681-5.663,3.107-3.931,4.95a59.334,59.334,0,0,0,5.205,3.612,5.431,5.431,0,0,0,1.026.573,34.449,34.449,0,0,0,3.35-6",
    transform: "translate(-31.393 -27.44)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14014",
    "data-name": "Group 14014",
    transform: "translate(196.855 169.638)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14013",
    "data-name": "Group 14013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14012",
    "data-name": "Group 14012",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40620",
    "data-name": "Path 40620",
    d: "M233.568,198.122a1.666,1.666,0,0,0-.612-.618,19.373,19.373,0,0,1-3.765,6.049,5.431,5.431,0,0,0,1.026.573,34.449,34.449,0,0,0,3.35-6",
    transform: "translate(-229.192 -197.504)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40621",
    "data-name": "Path 40621",
    d: "M261.689,215.823s-10.317,1.257-13.232,2.058-11.58.681-11.707.216-.2-4.515.965-5.252,9.76.276,11.056.171,8.327-3.106,9.337-2.7,3.581,5.5,3.581,5.5",
    transform: "translate(-33.393 -29.669)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40622",
    "data-name": "Path 40622",
    d: "M257.912,211.483a35.849,35.849,0,0,0-5.022,1.543,22.123,22.123,0,0,1-3.868,1.186,1.818,1.818,0,0,1-1.011-.245c-.945-.5-3.777.169-5.754.02a19.408,19.408,0,0,0-3.838-.088c-.391.412-.567,2.449-.542,3.566,1.928.216,8.159.228,10.476-.408,1.608-.441,6.851-.482,11.989-1.744a21.685,21.685,0,0,0-2.43-3.832",
    transform: "translate(-33.562 -29.838)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40623",
    "data-name": "Path 40623",
    d: "M252.546,219.5s1.125-7.88.722-8.094c-.145-.077-.532.078-.987.3a6.254,6.254,0,0,1-2.42.617l-3.555.222s-1.106,6.257-.51,6.549a11.853,11.853,0,0,0,2.619.273c.326.05,1.578.167,2.618.216a3.573,3.573,0,0,0,1.513-.082",
    transform: "translate(-34.655 -29.824)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14017",
    "data-name": "Group 14017",
    transform: "translate(216.378 181.56)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14016",
    "data-name": "Group 14016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14015",
    "data-name": "Group 14015",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40624",
    "data-name": "Path 40624",
    d: "M253.436,219.5s1.125-7.88.722-8.094c-.145-.077-.532.078-.987.3a68.465,68.465,0,0,1-1.248,7.876,3.574,3.574,0,0,0,1.513-.082",
    transform: "translate(-251.922 -211.384)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40625",
    "data-name": "Path 40625",
    d: "M240.43,212.624a1.662,1.662,0,0,0-.771-.4,30.8,30.8,0,0,0-5.566-.847c-2.981.245-4.438,4.693-2.225,5.917a59.47,59.47,0,0,0,6.061,1.842,5.48,5.48,0,0,0,1.153.23,34.38,34.38,0,0,0,1.348-6.742",
    transform: "translate(-32.563 -29.823)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14020",
    "data-name": "Group 14020",
    transform: "translate(205.366 182.401)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14019",
    "data-name": "Group 14019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14018",
    "data-name": "Group 14018",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40626",
    "data-name": "Path 40626",
    d: "M241.6,212.763a1.662,1.662,0,0,0-.771-.4,19.373,19.373,0,0,1-1.729,6.913,5.478,5.478,0,0,0,1.153.23,34.378,34.378,0,0,0,1.348-6.742",
    transform: "translate(-239.101 -212.363)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40627",
    "data-name": "Path 40627",
    d: "M345.187,174.044l-19.346,12.288a1.337,1.337,0,0,0,1.148,2.395l20.555-8.414Z",
    transform: "translate(-45.885 -24.556)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40628",
    "data-name": "Path 40628",
    d: "M345.86,175.826l-19.386,12.263a1.357,1.357,0,0,0-.569.729,1.335,1.335,0,0,0,1.181.161l20.555-8.415Z",
    transform: "translate(-45.982 -24.807)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40629",
    "data-name": "Path 40629",
    d: "M337.4,199.678c-6.771,3.873-14.89,2.414-18.135-3.26s-.388-13.412,6.383-17.285,14.889-2.414,18.135,3.259.388,13.413-6.383,17.286",
    transform: "translate(-44.856 -24.968)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40630",
    "data-name": "Path 40630",
    d: "M336.791,198.746c-5.947,3.4-12.878,2.47-15.483-2.082s.106-11,6.053-14.4,12.878-2.469,15.483,2.082-.106,11-6.053,14.4",
    transform: "translate(-45.194 -25.426)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40631",
    "data-name": "Path 40631",
    d: "M336.484,198.329c-5.717,3.271-12.221,2.653-14.528-1.379s.459-9.951,6.176-13.222,12.221-2.653,14.528,1.379-.459,9.951-6.176,13.222",
    transform: "translate(-45.31 -25.626)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40632",
    "data-name": "Path 40632",
    d: "M287.1,187.033a68.181,68.181,0,0,0-1.264-14.45c-.266-1.23-7.1-9.435-8.027-9.39s-4.572,1.8-3.659,4.208,4.587,6.4,4.822,7.186,1.208,11.787,1.208,11.787Z",
    transform: "translate(-38.66 -23.025)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40633",
    "data-name": "Path 40633",
    d: "M286.063,186.251c1.047-7.5-1.072-11.819-1.278-13.153-.6-1.381-5.337-7.04-6.951-8.316a4.645,4.645,0,0,0-2.154,1.56.862.862,0,0,0-.1.825,18.836,18.836,0,0,0,2.885,4.46,11.457,11.457,0,0,1,1.968,2.814c.222.744.22,4.441,1.076,10.707Z",
    transform: "translate(-38.872 -23.249)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40634",
    "data-name": "Path 40634",
    d: "M275.048,170.067a1.932,1.932,0,0,1-.855-.537,35.722,35.722,0,0,1-4.123-5.074c-1.51-3.128,2.087-7.2,4.614-5.708a68.788,68.788,0,0,1,5.411,4.984,6.416,6.416,0,0,1,.91,1.018c.021.293-5.553,5.359-5.957,5.317",
    transform: "translate(-38.054 -22.353)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14023",
    "data-name": "Group 14023",
    transform: "translate(236.139 141.38)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14022",
    "data-name": "Group 14022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14021",
    "data-name": "Group 14021",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40635",
    "data-name": "Path 40635",
    d: "M275.784,170.938a1.932,1.932,0,0,1-.855-.537,22.512,22.512,0,0,0,5.9-5.8,6.413,6.413,0,0,1,.91,1.018c.021.293-5.553,5.359-5.957,5.317",
    transform: "translate(-274.928 -164.604)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40636",
    "data-name": "Path 40636",
    d: "M279.218,176.1c.173,1.271.633,4.388.945,6.082a6.73,6.73,0,0,0,.256,1.126c.217.32,8.045-1.321,8.045-1.321s-.054-.461-.141-1.18c-.237-1.945-.728-5.769-1.109-7.4a2.083,2.083,0,0,0-.258-.747s-7.835,2.5-7.808,2.9c0,.056.029.249.07.542",
    transform: "translate(-39.385 -24.361)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14026",
    "data-name": "Group 14026",
    transform: "translate(239.763 148.304)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14025",
    "data-name": "Group 14025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14024",
    "data-name": "Group 14024",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40637",
    "data-name": "Path 40637",
    d: "M279.218,176.1a19.233,19.233,0,0,0,8-2.691,2.083,2.083,0,0,0-.258-.747s-7.835,2.5-7.808,2.9c0,.056.029.249.07.542",
    transform: "translate(-279.148 -172.665)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14029",
    "data-name": "Group 14029",
    transform: "translate(240.777 156.45)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14028",
    "data-name": "Group 14028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14027",
    "data-name": "Group 14027",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40638",
    "data-name": "Path 40638",
    d: "M280.329,183.523a6.692,6.692,0,0,0,.256,1.126c.217.32,8.045-1.321,8.045-1.321s-.054-.46-.141-1.179a44.646,44.646,0,0,1-8.16,1.374",
    transform: "translate(-280.329 -182.149)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40639",
    "data-name": "Path 40639",
    d: "M260.4,183.557s-9.5-4.224-12.409-5.036-10.283-5.368-10.153-5.832,2.153-3.974,3.528-4.009,8.23,5.253,9.4,5.829,8.74,1.617,9.4,2.487.243,6.56.243,6.56",
    transform: "translate(-33.556 -23.799)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40640",
    "data-name": "Path 40640",
    d: "M259.532,177.83a35.985,35.985,0,0,0-5.1-1.257,22.088,22.088,0,0,1-3.926-.971,1.82,1.82,0,0,1-.741-.73c-.552-.916-3.327-1.8-4.946-2.94a19.387,19.387,0,0,0-3.248-2.048c-.547.152-1.744,1.808-2.3,2.779,1.543,1.177,6.881,4.39,9.2,5.035,1.606.447,6.125,3.108,11.18,4.667a21.721,21.721,0,0,0-.115-4.537",
    transform: "translate(-33.759 -23.969)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40641",
    "data-name": "Path 40641",
    d: "M250.686,181.782s5.015-6.18,4.78-6.572c-.085-.141-.5-.205-1-.251a6.252,6.252,0,0,1-2.393-.715l-3.163-1.637s-4.165,4.8-3.8,5.355a11.738,11.738,0,0,0,2.105,1.58c.255.211,1.268.955,2.135,1.531.681.447,1.27.793,1.339.708",
    transform: "translate(-34.579 -24.353)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14032",
    "data-name": "Group 14032",
    transform: "translate(214.767 150.606)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14031",
    "data-name": "Group 14031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14030",
    "data-name": "Group 14030",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40642",
    "data-name": "Path 40642",
    d: "M251.386,182.168s5.015-6.18,4.78-6.572c-.085-.141-.5-.205-1-.251a68.565,68.565,0,0,1-5.119,6.115c.681.447,1.27.793,1.339.708",
    transform: "translate(-250.046 -175.346)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14035",
    "data-name": "Group 14035",
    transform: "translate(216.807 172.748)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14034",
    "data-name": "Group 14034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14033",
    "data-name": "Group 14033",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40643",
    "data-name": "Path 40643",
    d: "M253.288,201.343a2.091,2.091,0,0,0-.867-.218,17.536,17.536,0,0,1,.579,6.862,3.658,3.658,0,0,0,.78-.212c.21-.191-.18-6.192-.491-6.432",
    transform: "translate(-252.421 -201.125)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14038",
    "data-name": "Group 14038",
    transform: "translate(224.042 182.896)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14037",
    "data-name": "Group 14037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14036",
    "data-name": "Group 14036",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40644",
    "data-name": "Path 40644",
    d: "M261.712,213.158a2.092,2.092,0,0,0-.868-.218,17.536,17.536,0,0,1,.579,6.862,3.658,3.658,0,0,0,.78-.212c.21-.191-.18-6.192-.491-6.432",
    transform: "translate(-260.844 -212.94)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14041",
    "data-name": "Group 14041",
    transform: "translate(216.054 163.206)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14040",
    "data-name": "Group 14040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14039",
    "data-name": "Group 14039",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40645",
    "data-name": "Path 40645",
    d: "M253.6,190.475a2.286,2.286,0,0,0-.867-.46c.315,2.489-.62,5.779-1.185,7.465a4.065,4.065,0,0,0,.886-.021c.274-.149,1.434-6.646,1.166-6.983",
    transform: "translate(-251.544 -190.015)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14044",
    "data-name": "Group 14044",
    transform: "translate(221.217 153.642)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14043",
    "data-name": "Group 14043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14042",
    "data-name": "Group 14042",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40646",
    "data-name": "Path 40646",
    d: "M261.228,179.534a2.3,2.3,0,0,0-.732-.654c-.291,2.492-1.988,5.46-2.942,6.962a4.072,4.072,0,0,0,.866.192c.3-.079,2.987-6.108,2.808-6.5",
    transform: "translate(-257.555 -178.88)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14047",
    "data-name": "Group 14047",
    transform: "translate(238.801 158.424)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14046",
    "data-name": "Group 14046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14045",
    "data-name": "Group 14045",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40647",
    "data-name": "Path 40647",
    d: "M285.154,186.028a2.292,2.292,0,0,0,.4-.9c-2.463.48-5.807-.234-7.527-.685a4.029,4.029,0,0,0,.082.883c.166.264,6.726.988,7.045.7",
    transform: "translate(-278.028 -184.448)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40648",
    "data-name": "Path 40648",
    d: "M316.89,183.815l5.12,23.86s-6.119,1.3-9.833,2.1c-1.561.335-2.7.581-2.77.6l-7.778-22.813,5.939-1.461Z",
    transform: "translate(-42.557 -25.934)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40649",
    "data-name": "Path 40649",
    d: "M286.521,188.488s-6.96-9.771-18.58-12.223c-9.235-1.948-13.658,3.256-14.587,4.222a29.752,29.752,0,0,0-6.109,11.383s-2.2,6.116,2,13.181c0,0,5.978,9.143,11.231,10.157s23.418-2.191,23.418-2.191Z",
    transform: "translate(-34.803 -24.808)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14050",
    "data-name": "Group 14050",
    transform: "translate(259.073 160.17)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14049",
    "data-name": "Group 14049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14048",
    "data-name": "Group 14048",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40650",
    "data-name": "Path 40650",
    d: "M307.568,186.481a22.019,22.019,0,0,1,4.611,23.67c-1.561.335-2.7.581-2.771.6l-7.777-22.813Z",
    transform: "translate(-301.63 -186.481)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40651",
    "data-name": "Path 40651",
    d: "M336.962,185.968c2.6,2.671,4.074,6.345,1.828,11.132-2.583,5.5-8.14,8.63-13.535,10.46a59.2,59.2,0,0,1-10.023,2.323.623.623,0,0,1-.686-.807c4.191-13.224-2.74-21.39-5.3-23.849a.624.624,0,0,1,.3-1.059c8.478-1.931,16.35-3.71,16.821-3.762a22.04,22.04,0,0,1,10.6,5.562",
    transform: "translate(-43.604 -25.453)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14053",
    "data-name": "Group 14053",
    transform: "translate(281.651 160.515)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14052",
    "data-name": "Group 14052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14051",
    "data-name": "Group 14051",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40652",
    "data-name": "Path 40652",
    d: "M339.624,186.882c2.6,2.671,4.074,6.345,1.828,11.132-2.583,5.5-8.14,8.63-13.535,10.46,0,0,16.966-10.593,12.017-20.907-.112-.231-.214-.46-.31-.685",
    transform: "translate(-327.917 -186.882)",
    fill: "#b5b5b5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40653",
    "data-name": "Path 40653",
    d: "M279.012,210.353s-16.184-.4-20.045-1.336-5.129-13.018-4.1-15.748,11.712-10.144,13.175-10.415,14.151,8.34,15.086,9.819-1.772,17.749-4.115,17.68",
    transform: "translate(-35.911 -25.798)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40654",
    "data-name": "Path 40654",
    d: "M308.466,210.482a1.51,1.51,0,0,1-.934.872c-3.3,1.074-14.541,4.731-17.635,3.619a7.616,7.616,0,0,1-1.839-1,18.759,18.759,0,0,1-6.958-11.992c-.672-4.727,1.838-11.879,3.09-12.166l1.18-.27c2.667-.612,9.479-2.175,16.54-3.788a1.525,1.525,0,0,1,1.41.405,22.031,22.031,0,0,1,5.146,24.322",
    transform: "translate(-39.645 -26.203)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40655",
    "data-name": "Path 40655",
    d: "M336.446,199.851c-3.76,2.151-8.188,1.482-9.889-1.494s-.036-7.132,3.724-9.282,8.186-1.482,9.889,1.495.034,7.131-3.724,9.281",
    transform: "translate(-45.98 -26.499)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40656",
    "data-name": "Path 40656",
    d: "M374.987,180.494c-1.507-.167-3.354-1.121-5.392-4.157a11.378,11.378,0,0,1-.381-12.346,14.9,14.9,0,0,1,2.3.213c.258.042.5.094.745.15a12.3,12.3,0,0,1,4.9,2.2c2.267,4.423,2.688,7.106,1.482,9.577a10.029,10.029,0,0,1-1.434,2.115,24.918,24.918,0,0,1-2.215,2.247",
    transform: "translate(-51.86 -23.137)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14056",
    "data-name": "Group 14056",
    transform: "translate(315.709 140.854)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14055",
    "data-name": "Group 14055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14054",
    "data-name": "Group 14054",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40657",
    "data-name": "Path 40657",
    d: "M374.987,180.494c-1.507-.167-3.354-1.121-5.392-4.157a11.378,11.378,0,0,1-.381-12.346,14.9,14.9,0,0,1,2.3.213c.258.042.5.094.745.15a13.085,13.085,0,0,1,4.3,5.579,12.639,12.639,0,0,1,.646,8.313,24.918,24.918,0,0,1-2.215,2.247",
    transform: "translate(-367.569 -163.991)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40658",
    "data-name": "Path 40658",
    d: "M393.66,156.571l-35.481,16.5,1.52,3.666L394.661,160Z",
    transform: "translate(-50.535 -22.091)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40659",
    "data-name": "Path 40659",
    d: "M396.177,161.508l-34.828,17.854,1.72,3.577,34.3-18.065Z",
    transform: "translate(-50.983 -22.787)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40660",
    "data-name": "Path 40660",
    d: "M370.626,182.454c-6.4,5.531-15.689,6.072-15.689,6.072l-7.145-15.386s5.189-6.748,13.441-9a17.1,17.1,0,0,1,6.607-.538h.009a.623.623,0,0,1,.508.837c-.883,2.422-1.893,6.775.347,10.42,2.509,4.082,4.782,3.394,6.636,2.116a.22.22,0,0,1,.314.3c-.112.177-.234.354-.364.528l-.005.005a30.885,30.885,0,0,1-4.659,4.653",
    transform: "translate(-49.07 -23.066)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14059",
    "data-name": "Group 14059",
    transform: "translate(317.299 140.532)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14058",
    "data-name": "Group 14058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14057",
    "data-name": "Group 14057",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40661",
    "data-name": "Path 40661",
    d: "M378.341,177.814l-.005.005c-1.33.943-4.419,2.319-7.288-2.447a12.076,12.076,0,0,1-.156-11.756h.008a.623.623,0,0,1,.508.837c-.883,2.421-1.892,6.774.347,10.419,2.51,4.082,4.782,3.394,6.636,2.116a.221.221,0,0,1,.315.3c-.113.176-.235.353-.365.527",
    transform: "translate(-369.42 -163.617)",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40662",
    "data-name": "Path 40662",
    d: "M350.649,183.086l-20.09,12.761a1.389,1.389,0,0,0,1.192,2.487l20.663-7.043Z",
    transform: "translate(-46.548 -25.832)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40663",
    "data-name": "Path 40663",
    d: "M334.427,200.493a1.662,1.662,0,1,1-.072-2.35,1.663,1.663,0,0,1,.072,2.35",
    transform: "translate(-46.779 -27.892)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40664",
    "data-name": "Path 40664",
    d: "M334.717,200.766a1.542,1.542,0,1,1-.067-2.179,1.542,1.542,0,0,1,.067,2.179",
    transform: "translate(-46.849 -27.96)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40665",
    "data-name": "Path 40665",
    d: "M334.8,200.85a1.24,1.24,0,1,1-.053-1.752,1.24,1.24,0,0,1,.053,1.752",
    transform: "translate(-46.935 -28.043)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40666",
    "data-name": "Path 40666",
    d: "M244.062,169.663a1.662,1.662,0,0,0-.456-.74,30.833,30.833,0,0,0-4.339-3.587c-2.683-1.323-6.219,1.745-4.949,3.932a59.6,59.6,0,0,0,4.252,4.7,5.6,5.6,0,0,0,.87.79,34.389,34.389,0,0,0,4.622-5.092",
    transform: "translate(-33.022 -23.282)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14062",
    "data-name": "Group 14062",
    transform: "translate(205.548 145.641)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14061",
    "data-name": "Group 14061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14060",
    "data-name": "Group 14060",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40667",
    "data-name": "Path 40667",
    d: "M244.8,170.3a1.662,1.662,0,0,0-.456-.74,19.384,19.384,0,0,1-5.036,5.042,5.6,5.6,0,0,0,.87.79A34.391,34.391,0,0,0,244.8,170.3",
    transform: "translate(-239.312 -169.565)",
    fill: "#dee2e3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40668",
    "data-name": "Path 40668",
    d: "M390.669,161.015a5.67,5.67,0,1,0,5.442-5.889,5.669,5.669,0,0,0-5.442,5.889",
    transform: "translate(-55.119 -21.886)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40669",
    "data-name": "Path 40669",
    d: "M398.72,160.691a2.131,2.131,0,1,1-2.707-1.324,2.131,2.131,0,0,1,2.707,1.324",
    transform: "translate(-55.67 -22.469)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40670",
    "data-name": "Path 40670",
    d: "M399.194,160.562a1.976,1.976,0,1,1-2.511-1.227,1.975,1.975,0,0,1,2.511,1.227",
    transform: "translate(-55.78 -22.465)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40671",
    "data-name": "Path 40671",
    d: "M399.318,160.6a1.59,1.59,0,1,1-2.019-.988,1.589,1.589,0,0,1,2.019.988",
    transform: "translate(-55.903 -22.508)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40672",
    "data-name": "Path 40672",
    d: "M385.789,256.742a4.824,4.824,0,0,1,2.02,1.662l4.939,7.218-5.614,6.706a4.82,4.82,0,0,1-2.171,1.458s-22.017,4.988-29.517,5.5c-5.47.371-21.914-1.062-21.914-1.062s-6.4-7.564-6-15.762,7.5-15.107,7.5-15.107,16.506.164,21.914,1.062c7.415,1.233,28.846,8.327,28.846,8.327",
    transform: "translate(-46.209 -34.899)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40673",
    "data-name": "Path 40673",
    d: "M385.917,254.1a4.825,4.825,0,0,1,2.02,1.662l4.938,7.218-5.613,6.706a4.82,4.82,0,0,1-2.171,1.458s-22.017,4.988-29.517,5.5c-5.47.371-21.914-1.062-21.914-1.062s-6.4-7.564-6-15.762,7.5-15.107,7.5-15.107,16.506.164,21.914,1.062c7.415,1.233,28.846,8.327,28.846,8.327",
    transform: "translate(-46.227 -34.526)",
    fill: "#616364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40674",
    "data-name": "Path 40674",
    d: "M403.3,265.982l-.11,2.268-1.209,1.445-.453-1.6Z",
    transform: "translate(-56.652 -37.527)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40675",
    "data-name": "Path 40675",
    d: "M331.81,236.385a20.572,20.572,0,1,0,19.551,21.545,20.572,20.572,0,0,0-19.551-21.545",
    transform: "translate(-43.772 -33.348)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40676",
    "data-name": "Path 40676",
    d: "M331.922,237.5a19.61,19.61,0,1,0,18.637,20.537A19.611,19.611,0,0,0,331.922,237.5",
    transform: "translate(-43.93 -33.506)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40677",
    "data-name": "Path 40677",
    d: "M332.2,240.318a17.191,17.191,0,1,0,16.338,18,17.192,17.192,0,0,0-16.338-18",
    transform: "translate(-44.327 -33.903)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40678",
    "data-name": "Path 40678",
    d: "M386.065,251.06a4.825,4.825,0,0,1,2.02,1.662l4.939,7.218-5.614,6.706a4.82,4.82,0,0,1-2.171,1.458s-22.017,4.988-29.517,5.5c-5.47.371-21.914-1.062-21.914-1.062s-6.4-7.564-6-15.762,7.5-15.107,7.5-15.107,16.506.164,21.914,1.062c7.415,1.233,28.846,8.327,28.846,8.327",
    transform: "translate(-46.248 -34.097)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40679",
    "data-name": "Path 40679",
    d: "M386.193,248.419a4.824,4.824,0,0,1,2.02,1.662l4.939,7.218-5.614,6.706a4.825,4.825,0,0,1-2.171,1.458s-22.017,4.988-29.517,5.5c-5.47.371-21.914-1.062-21.914-1.062s-6.4-7.564-6-15.762,7.5-15.107,7.5-15.107,16.506.164,21.914,1.062c7.415,1.233,28.846,8.327,28.846,8.327",
    transform: "translate(-46.266 -33.725)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40680",
    "data-name": "Path 40680",
    d: "M403.576,260.3l-.11,2.268-1.209,1.445-.453-1.6Z",
    transform: "translate(-56.69 -36.726)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40681",
    "data-name": "Path 40681",
    d: "M200.184,282.537l31.807,56.588,12.842-11.014,8.438-7.238,10.135-8.691L238.68,267.349l-8.065,3.181-5.6,2.212Z",
    transform: "translate(-28.244 -37.72)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40682",
    "data-name": "Path 40682",
    d: "M197.753,260.241l-.163,10.567-18.37,11.953,3.638,6.594s18.733-11.009,18.933-11.119,3.948-6.919,3.948-6.919l-3.046-6.088-1.969-1.988Z",
    transform: "translate(-25.286 -36.717)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40683",
    "data-name": "Path 40683",
    d: "M201.056,263.733,202.994,271l-7.714,8.356-13.7,7.558,1.615,2.928s18.733-11.01,18.933-11.119,3.948-6.919,3.948-6.919l-3.046-6.088Z",
    transform: "translate(-25.618 -37.21)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40684",
    "data-name": "Path 40684",
    d: "M239.947,345.1l-4.987,3.571-26.976-49.313,3.7-25.985,4.6,4.471,2.787,28.3Z",
    transform: "translate(-29.344 -38.571)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14065",
    "data-name": "Group 14065",
    transform: "translate(196.767 232.808)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14064",
    "data-name": "Group 14064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14063",
    "data-name": "Group 14063",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40685",
    "data-name": "Path 40685",
    d: "M229.089,273.263l1.368,21.91,18.454,33.459,8.439-7.237-22.656-50.344Z",
    transform: "translate(-229.089 -271.051)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40686",
    "data-name": "Path 40686",
    d: "M230.008,266.763l1.05,15.882.1,1.542.466,7.09-1.062.076-.476.033,7.642,13.855,1.458-.8,11.871,21.524,57.8-44.912-.007-.012c6.6-4.1,7.7-14.948,2.388-24.587a27.774,27.774,0,0,0-4.12-5.672q-.527-.56-1.077-1.074c-5.239-4.927-11.789-6.82-16.873-4.353l-.005-.009-59.139,21.415a.069.069,0,0,0-.018.007",
    transform: "translate(-32.452 -34.464)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40687",
    "data-name": "Path 40687",
    d: "M216.908,274.7l9.832,17.827L225.3,271.661Z",
    transform: "translate(-30.604 -38.329)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40688",
    "data-name": "Path 40688",
    d: "M213.854,298.744l27.17,49.262,2.864-2.329,3.141-12.623-12.617-22.876,1.04-.574-7.642-13.855-1.306.09-.194-2.811L216.477,275.2Z",
    transform: "translate(-30.173 -38.828)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40689",
    "data-name": "Path 40689",
    d: "M201.965,263.81l2.13,8.031-7.952,8.684-15.727,8.831,39.023,70.754,14.51-11.8-27.718-50.256,2.956-27.036Z",
    transform: "translate(-25.455 -37.221)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40690",
    "data-name": "Path 40690",
    d: "M158.769,254.3l17.422,31.588,14.267-7.869,8.427-9.041-2.567-9.1-3.646-3.641Z",
    transform: "translate(-22.401 -35.879)",
    fill: "#dee2e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14068",
    "data-name": "Group 14068",
    transform: "translate(197.556 209.807)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14067",
    "data-name": "Group 14067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14066",
    "data-name": "Group 14066",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40691",
    "data-name": "Path 40691",
    d: "M230.008,266.763l1.05,15.882L306.044,249.7c-5.239-4.927-11.789-6.82-16.873-4.353l-.005-.009-59.139,21.415a.069.069,0,0,0-.018.007",
    transform: "translate(-230.008 -244.271)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40692",
    "data-name": "Path 40692",
    d: "M231.719,292.346l-1.063.076.195,1.248,6.971,12.639,1.458-.8,11.872,21.524,57.8-44.912-.007-.012c6.6-4.1,7.7-14.949,2.388-24.587a27.742,27.742,0,0,0-4.121-5.672l-75.959,33.41Z",
    transform: "translate(-32.543 -35.533)",
    fill: "#cacccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40693",
    "data-name": "Path 40693",
    d: "M228.759,297.964a9.547,9.547,0,1,0,12.97,3.749,9.547,9.547,0,0,0-12.97-3.749",
    transform: "translate(-31.579 -41.872)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40694",
    "data-name": "Path 40694",
    d: "M229.927,299.842a7.742,7.742,0,1,0,10.517,3.041,7.741,7.741,0,0,0-10.517-3.041",
    transform: "translate(-31.875 -42.169)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40695",
    "data-name": "Path 40695",
    d: "M230.943,301.473a6.173,6.173,0,1,0,8.387,2.424,6.173,6.173,0,0,0-8.387-2.424",
    transform: "translate(-32.133 -42.426)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40696",
    "data-name": "Path 40696",
    d: "M238.532,346.983l-26.3-47.891,2.789-22.617,1,.969-2.394,21.48,26.054,47.238Z",
    transform: "translate(-29.944 -39.008)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40697",
    "data-name": "Path 40697",
    d: "M214.881,354.582l.949,1.721,9.223-2.328,6.891-6.558-.95-1.722-6.89,6.558Z",
    transform: "translate(-30.318 -48.774)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40698",
    "data-name": "Path 40698",
    d: "M231.766,347.095l.287.52-6.891,6.558-9.223,2.329-.286-.52,9.223-2.329Z",
    transform: "translate(-30.426 -48.971)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40699",
    "data-name": "Path 40699",
    d: "M192.669,314.308l-.949-1.721,6.89-6.558,9.223-2.329.949,1.721-9.223,2.329Z",
    transform: "translate(-27.05 -42.849)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40700",
    "data-name": "Path 40700",
    d: "M208.119,304.219l-.287-.52-9.222,2.329-6.891,6.558.287.52,6.89-6.558Z",
    transform: "translate(-27.05 -42.849)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31981",
    "data-name": "Rectangle 31981",
    width: 7.244,
    height: 51.536,
    transform: "translate(291.885 192.864)",
    fill: "#6f5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40701",
    "data-name": "Path 40701",
    d: "M382.94,229.6H302.276a2.314,2.314,0,0,1-2.314-2.314V215.56a2.314,2.314,0,0,1,2.314-2.314H382.94Z",
    transform: "translate(-42.322 -30.087)",
    fill: "#866db3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40702",
    "data-name": "Path 40702",
    d: "M506.2,433.808a7.707,7.707,0,0,1-15.413,0",
    transform: "translate(-69.245 -61.206)",
    fill: "#5b5a8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31982",
    "data-name": "Rectangle 31982",
    width: 13.882,
    height: 62.283,
    transform: "translate(353.32 280.397)",
    fill: "#bcbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40703",
    "data-name": "Path 40703",
    d: "M411.358,326.663v19.5L425.24,341.9v-15.24Z",
    transform: "translate(-58.038 -46.089)",
    fill: "#838499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40704",
    "data-name": "Path 40704",
    d: "M406.462,403.6l.412,4.737a3.9,3.9,0,0,0,3.919,3.565l15.12-.119a3.9,3.9,0,0,0,3.874-3.9V404.16l-17.724-.563Z",
    transform: "translate(-57.348 -56.943)",
    fill: "#bcbebe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31983",
    "data-name": "Rectangle 31983",
    width: 35.987,
    height: 23.975,
    rx: 8.778,
    transform: "translate(342.267 264.248)",
    fill: "#464778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40705",
    "data-name": "Path 40705",
    d: "M455.784,318.076c0-3.555-3.394-6.462-7.54-6.462h-71.9c-4.148,0-7.54,2.907-7.54,6.462s3.393,6.463,7.54,6.463h71.9c4.147,0,7.54-2.908,7.54-6.463",
    transform: "translate(-52.035 -43.966)",
    fill: "#3e3e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40706",
    "data-name": "Path 40706",
    d: "M425.391,244.9c-.5,4.28.586,8.254,2.407,8.832l36.346,11.53c1.822.579,3.688-2.463,4.148-6.758l5.169-48.273a115.133,115.133,0,0,0,.4-15.528L468.5,100.217c-.24-4.246-1.865-8.692-3.607-9.882L451.178,79.978c-1.744-1.189-6.7-4.447-8.559-4.535l-4.364-.207c-1.856-.088-4.178,2.91-4.252,7.253V186.672c-.074,4.344-7.261,33.9-7.759,38.18Z",
    transform: "translate(-60.001 -10.615)",
    fill: "#866db3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40707",
    "data-name": "Path 40707",
    d: "M435.533,248.184c-.4,4.093.508,7.5,2.027,7.572l29.618,1.4c1.519.072,3.091-3.217,3.495-7.311l4.537-46a138.994,138.994,0,0,0,.506-14.834L472.485,84.1c-.125-4.066-1.471-7.451-2.989-7.523L446.1,75.469c-1.519-.072-2.834,3.254-2.921,7.39l.205,104.049c-.088,4.137-3.154,13.62-3.558,17.712Z",
    transform: "translate(-61.436 -10.648)",
    fill: "#504070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31984",
    "data-name": "Rectangle 31984",
    d: "M13.748,0H133.209a13.748,13.748,0,0,1,13.748,13.748v0A13.749,13.749,0,0,1,133.208,27.5H13.749A13.749,13.749,0,0,1,0,13.748v0A13.748,13.748,0,0,1,13.748,0Z",
    transform: "translate(273.183 244.4)",
    fill: "#6f5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40708",
    "data-name": "Path 40708",
    d: "M340.273,414.652l68-12.556,68.988,12.556",
    transform: "translate(-48.009 -56.732)",
    fill: "none",
    stroke: "#bcbebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.778
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40709",
    "data-name": "Path 40709",
    d: "M346.778,433.808a7.707,7.707,0,0,1-15.413,0",
    transform: "translate(-46.752 -61.206)",
    fill: "#5b5a8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40710",
    "data-name": "Path 40710",
    d: "M331.18,432.61a1.132,1.132,0,0,1-1.131-1.131,8.838,8.838,0,0,1,17.675,0,1.132,1.132,0,0,1-1.131,1.131Z",
    transform: "translate(-46.567 -59.63)",
    fill: "#bcbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40711",
    "data-name": "Path 40711",
    d: "M338.7,421.325a9.98,9.98,0,0,0-9.969,9.968,2.262,2.262,0,0,0,2.261,2.262h15.413a2.262,2.262,0,0,0,2.262-2.262,9.979,9.979,0,0,0-9.968-9.968m0,2.262a7.706,7.706,0,0,1,7.706,7.706H330.993a7.706,7.706,0,0,1,7.707-7.706",
    transform: "translate(-46.381 -59.445)",
    fill: "#bcbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40712",
    "data-name": "Path 40712",
    d: "M490.6,432.61a1.132,1.132,0,0,1-1.131-1.131,8.838,8.838,0,0,1,17.675,0,1.132,1.132,0,0,1-1.131,1.131Z",
    transform: "translate(-69.059 -59.63)",
    fill: "#bcbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40713",
    "data-name": "Path 40713",
    d: "M498.121,421.325a9.979,9.979,0,0,0-9.968,9.968,2.262,2.262,0,0,0,2.261,2.262h15.413a2.262,2.262,0,0,0,2.262-2.262,9.979,9.979,0,0,0-9.969-9.968m0,2.262a7.706,7.706,0,0,1,7.707,7.706H490.415a7.706,7.706,0,0,1,7.706-7.706",
    transform: "translate(-68.873 -59.445)",
    fill: "#bcbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40714",
    "data-name": "Path 40714",
    d: "M427.371,396.32V378.6a3.782,3.782,0,0,0-3.771-3.77H412.16a3.782,3.782,0,0,0-3.771,3.77V396.32",
    transform: "translate(-57.619 -52.885)",
    fill: "#3e3e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40715",
    "data-name": "Path 40715",
    d: "M340.338,425.475v-8.16m136.927,8.16v-8.16",
    transform: "translate(-48.018 -58.879)",
    fill: "none",
    stroke: "#bcbebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.778
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40716",
    "data-name": "Path 40716",
    d: "M381.485,113.55c-.025.061-.038.1-.038.1a.38.38,0,0,1,.038-.1",
    transform: "translate(-53.818 -16.021)",
    fill: "#f9c771"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14078",
    "data-name": "Group 14078",
    transform: "translate(149.97 72.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14077",
    "data-name": "Group 14077",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40720",
    "data-name": "Path 40720",
    d: "M36.468,19.135c0,10.568-8.163,19.135-18.234,19.135S0,29.7,0,19.135,8.163,0,18.234,0,36.468,8.567,36.468,19.135",
    transform: "translate(0 0)",
    fill: "#3d7022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40721",
    "data-name": "Path 40721",
    d: "M35.972,19.91c0,9.777-7.562,17.7-16.89,17.7s-16.89-7.925-16.89-17.7,7.562-17.7,16.89-17.7,16.89,7.925,16.89,17.7",
    transform: "translate(-0.839 -0.845)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40722",
    "data-name": "Path 40722",
    d: "M34.865,21.808c0,8.088-6.255,14.645-13.972,14.645S6.92,29.9,6.92,21.808,13.176,7.163,20.893,7.163,34.865,13.72,34.865,21.808",
    transform: "translate(-2.65 -2.743)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40723",
    "data-name": "Path 40723",
    d: "M34.39,21.792c0,7.912-6.149,14.326-13.735,14.326S6.92,29.7,6.92,21.792,13.069,7.466,20.655,7.466,34.39,13.88,34.39,21.792",
    transform: "translate(-2.65 -2.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40724",
    "data-name": "Path 40724",
    d: "M26.717,17.485l.007,8.578H19.333",
    transform: "translate(-7.403 -6.695)",
    fill: "none",
    stroke: "#3d7022",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40725",
    "data-name": "Path 40725",
    d: "M26.291,17.106l.007,8.578H18.907",
    transform: "translate(-7.24 -6.55)",
    fill: "none",
    stroke: "#559c33",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14072",
    "data-name": "Group 14072",
    transform: "translate(404.792 159.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14071",
    "data-name": "Group 14071",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31986",
    "data-name": "Rectangle 31986",
    width: 0.399,
    height: 0.369,
    transform: "translate(0 0)",
    fill: "#8d412c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14074",
    "data-name": "Group 14074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14073",
    "data-name": "Group 14073",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40718",
    "data-name": "Path 40718",
    d: "M453.086,183.175c-.227,0-.423-.008-.6-.023Z",
    transform: "translate(-63.842 -25.841)",
    fill: "#1f151e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31987",
    "data-name": "Rectangle 31987",
    width: 0.588,
    height: 0.001,
    transform: "translate(425.503 183.159)",
    fill: "#f4a26c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRobot401);
export default __webpack_public_path__ + "static/media/Error_Robot_401.1cbabdb1dbd76741c65ef3cc75e56204.svg";
export { ForwardRef as ReactComponent };